// extracted by mini-css-extract-plugin
export default {"list":"Quote_list__AA4Tt","container":"Quote_container__MGG9s"};